import SepoliaBitcoinRedeemer from "@acre-btc/contracts/deployments/sepolia/BitcoinRedeemerV2.json";
import MainnetBitcoinRedeemer from "@acre-btc/contracts/deployments/mainnet/BitcoinRedeemerV2.json";
import { EthersContractWrapper, } from "./contract";
export default class EthereumBitcoinRedeemer
// @ts-expect-error TODO: Figure out why type generated by typechain does not
// satisfy the constraint `Contract`. Error: `Property '[internal]' is missing
// in type 'BitcoinRedeemer' but required in type 'Contract'`.
 extends EthersContractWrapper {
    #cache;
    #tbtcBridge;
    #runner;
    constructor(config, network) {
        let artifact;
        switch (network) {
            case "sepolia":
                artifact = SepoliaBitcoinRedeemer;
                break;
            case "mainnet":
                // TODO: set the new mainnet address
                artifact = MainnetBitcoinRedeemer;
                break;
            default:
                throw new Error("Unsupported network");
        }
        super(config, artifact);
        this.#runner = config.runner;
        this.#cache = {
            tbtcBridgeRedemptionParameters: undefined,
        };
    }
    setTbtcContracts({ tbtcBridge }) {
        this.#tbtcBridge = tbtcBridge;
    }
    /**
     * @see {BitcoinRedeemer#getChainIdentifier}
     */
    getChainIdentifier() {
        return this.getAddress();
    }
    /**
     * @see {BitcoinRedeemer#calculateWithdrawalFee}
     */
    async calculateWithdrawalFee(amountToWithdraw) {
        const { redemptionTreasuryFeeDivisor } = await this.#getTbtcBridgeRedemptionParameters();
        const treasuryFee = redemptionTreasuryFeeDivisor > 0
            ? amountToWithdraw / redemptionTreasuryFeeDivisor
            : 0n;
        return {
            tbtc: {
                treasuryFee,
            },
        };
    }
    // TODO: Consider exposing it from tBTC SDK.
    async #getTbtcBridgeRedemptionParameters() {
        if (this.#cache.tbtcBridgeRedemptionParameters) {
            return this.#cache.tbtcBridgeRedemptionParameters;
        }
        if (!this.#tbtcBridge) {
            throw new Error("tBTC contracts not set");
        }
        const { redemptionTreasuryFeeDivisor } = await this.#tbtcBridge.redemptionParameters();
        this.#cache.tbtcBridgeRedemptionParameters = {
            redemptionTreasuryFeeDivisor,
        };
        return this.#cache.tbtcBridgeRedemptionParameters;
    }
    /**
     * @see {BitcoinRedeemer#findRedemptionRequestIdFromTransaction}
     */
    async findRedemptionRequestIdFromTransaction(transactionHash) {
        const receipt = await this.#runner.provider?.getTransactionReceipt(transactionHash.toPrefixedString());
        if (!receipt)
            throw new Error(`Cannot find the redemption request id. Transaction with hash ${transactionHash.toPrefixedString()} not found`);
        const eventTopic = this.instance.interface.getEvent("RedemptionRequested").topicHash;
        // We assume only one redemption was requested in this transaction.
        const log = receipt.logs.find((receiptLog) => receiptLog.topics[0] === eventTopic);
        if (!log)
            throw new Error("Cannot find the redemption request id. The RedemptionRequested event not found");
        // @ts-expect-error Something is off with types.
        const parsedLog = this.instance.interface.parseLog(log);
        if (!parsedLog)
            throw new Error("Cannot find the redemption request id. Cannot parse log");
        return parsedLog.args[1];
    }
}
//# sourceMappingURL=bitcoin-redeemer.js.map